import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import { cn } from "@tudigo-monorepo/core-tudigo-theme";
import { PageEnum, useSpaceContext } from "@tudigo-monorepo/tudigo-session";

import { ProjectCardComposed } from "./project-card/composed/project-card.composed";

type ProjectsCardGridProps = {
  projects: Project[];
  className?: string;
  cardClassName?: string;
};

export const ProjectsCardGrid = ({
  projects,
  className,
  cardClassName,
}: ProjectsCardGridProps) => {
  const { currentPagePaths } = useSpaceContext();

  return (
    <section
      className={cn(
        "grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4",
        className,
      )}
    >
      {projects.map((project: Project) => (
        <ProjectCardComposed
          key={project.id}
          project={project}
          className={cn("min-w-[300px]", cardClassName)}
          to={currentPagePaths[PageEnum.PROJECT].replace(
            ":projectId",
            project.content?.slug ?? project.id,
          )}
        />
      ))}
    </section>
  );
};
